import Navbar from "../../components/navbar/Navbar";
import Hero from "../../components/hero/Hero";
// import CardGallery from "../../components/gallery/CardGallery";
import Footer from "../../components/footer/Footer";
// import HeroBanner from "../../components/heroBanner/HeroBanner";
// import pizzaImage from "../../assets/images/pizza-dx.jpeg";
import "./Home.css";
import LinkSection from "../../components/LinkSection/LinkSection";
import Gallery from "../../components/gallery/Gallery";
import Seo from "../../components/Seo";

export default function Home() {
    return (
        <>  <div className="home-container">
                <Seo
                    title="Pizzeria a Cecina | Busca Vida Pizzeria"
                    description="Busca Vida, pizzeria a Cecina in Viale della Repubblica. Pizza croccante, schiacciatini, cucina italiana e specialità di mare. Scopri il menu e prenota."
                    path="/"
                />
                <Navbar />
                <main>
                    <Hero title="Busca Vida"/>
                    <section className="local-seo-intro" aria-labelledby="pizzeria-cecina-title">
                        <p className="local-seo-kicker">Busca Vida · Cecina</p>
                        <h2 id="pizzeria-cecina-title">Pizzeria e cucina italiana a Cecina</h2>
                        <p>
                            In Viale della Repubblica 29 trovi pizza croccante dall’impasto
                            leggero, schiacciatini, antipasti, primi, secondi e specialità
                            di mare. Consulta il menu e chiamaci per prenotare il tuo tavolo.
                        </p>
                    </section>
                    <LinkSection />
                    <Gallery />
                    {/*<div className="pizzeria-image-container"><img src={pizzeriaImage} alt="Pizzeria interna" className="pizzeria-image"/></div>*/}
                    {/*<CardGallery />*/}
                    {/*<AboutPizzeria />*/}
                    {/*<MenuLinks />*/}
                    {/*<ContactInfo />*/}
                </main>
                <Footer />
            </div>
        </>
    );
}
